module.exports = __webpack_public_path__ + "img/icon-two.b8bac40c.png";